import Wordmark from '../../../../ui/Wordmark';

const ImageNavigation = () => {
    return <Wordmark inverted />;
};

export default ImageNavigation;
